import { render, staticRenderFns } from "./HeaderSubModality.vue?vue&type=template&id=e29aa386"
import script from "./HeaderSubModality.vue?vue&type=script&lang=js"
export * from "./HeaderSubModality.vue?vue&type=script&lang=js"
import style0 from "./HeaderSubModality.vue?vue&type=style&index=0&id=e29aa386&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports